
{
  "familyId": "GET-PROC-AFNAME",
  "questions": [
    {
      "id": "GET-PROC-AFNAME-001",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een winkelmanager verlaagt de prijs van een laptop van €875 met 24% korting. Wat betaalt de klant?",
      "options": [
        "€665",
        "€851",
        "€210",
        "€660"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 24,
            "label": "24% korting op €875 → €210 eraf, €665 te betalen",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 24% korting" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Korting bij een niet-rond percentage",
            "content": "Gebruik de 1%-methode: 1% van €875 = €8,75. Dan 24% = 24 × €8,75 = €210 korting. Te betalen: €875 − €210 = €665. Of direct: €875 × 0,76 = €665.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_korting",
      "variantIndex": 1,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "proc.korting-als-vast-bedrag", "label": "24 i.p.v. 24% afgetrokken", "optionIndex": 1 },
          { "id": "proc.afname-korting-als-eindbedrag", "label": "Korting als eindbedrag genomen", "optionIndex": 2 },
          { "id": "proc.afname-percentage-verwisseld", "label": "25%-truc gebruikt i.p.v. 24%", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "24% is geen 'kwart-truc' — je moet exact rekenen. 1% van €875 = €8,75. Dan 24% = 24 × €8,75 = €210 korting. De klant betaalt €875 − €210 = €665. Of direct: €875 × 0,76 = €665. Tegenproef: 24% van €665 + €665 ≈ €825 — past niet bij €875, dus check de richting.",
        "solutionSteps": [
          "1% van €875 = €8,75",
          "24% = 24 × €8,75 = €210 korting",
          "Te betalen: €875 − €210 = €665",
          "Of direct: €875 × 0,76 = €665"
        ],
        "distractorExplanations": {
          "0": "Goed! 1% van €875 = €8,75, dus 24% = €210 korting. €875 − €210 = €665.",
          "1": "Je hebt waarschijnlijk €24 afgetrokken in plaats van 24%. Maar 24% van €875 = €210, niet €24. Onthoud: procent betekent 'per honderd' — eerst uitrekenen, dan aftrekken.",
          "2": "€210 is de korting zelf, niet wat de klant betaalt. Trek af van de oude prijs: €875 − €210 = €665.",
          "3": "Je hebt waarschijnlijk de 25%-truc gebruikt: ¼ × €875 = €218,75 → €656,25 ≈ €660. Maar 24% ≠ 25%. Reken exact: 1% = €8,75 → 24% = €210 → €665."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-002",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een financieel adviseur berekent de afname-factor bij 30% waardedaling. Met welke factor vermenigvuldig je?",
      "options": [
        "0,70",
        "0,30",
        "1,30",
        "0,07"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 30,
            "label": "30% afname → 70% blijft → factor 0,70",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 30% afname, 70% blijft" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afname-factor berekenen",
            "content": "Bij een afname trek je het percentage af van 100%. De afname-factor = 1 − percentage als decimaal. Dus bij 30% afname: factor = 1 − 0,30 = 0,70.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_factor",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "proc.afname-percentage-verwisseld", "label": "Gebruikt percentage als factor i.p.v. complement", "optionIndex": 1 },
          { "id": "proc.toename-als-afname", "label": "Gebruikt toename-factor i.p.v. afname-factor", "optionIndex": 2 },
          { "id": "rek.rekenfout", "label": "Decimaal-conversiefout (30% = 0,03)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Bij een afname van 30% houd je 100% − 30% = 70% over. Als decimaal: 70% = 0,70. De afname-factor is dus 0,70.",
        "solutionSteps": [
          "Schrijf het percentage als decimaal: 30% = 0,30",
          "Trek af van 1: factor = 1 − 0,30 = 0,70",
          "Check: 0,70 = 70% — je houdt 70% over na 30% afname ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Afname van 30% → factor = 1 − 0,30 = 0,70.",
          "1": "Je dacht waarschijnlijk dat het percentage zelf de factor is. Maar 0,30 is de afname, niet de factor waarmee je vermenigvuldigt. Onthoud: de afname-factor = 1 − het percentage als decimaal, dus 1 − 0,30 = 0,70.",
          "2": "Je dacht waarschijnlijk dat je het percentage moet optellen bij 1. Maar 1 + 0,30 = 1,30 is een toename-factor (30% erbij), niet een afname-factor. Onthoud: bij afname trek je af, bij toename tel je op.",
          "3": "Je dacht waarschijnlijk dat 30% = 0,03. Maar 30% = 0,30 (deel door 100, niet door 1000). Onthoud: om procenten om te zetten naar decimalen, deel je door 100."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-003",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een autohandelaar taxeert een auto op €15.000. Na een jaar is de waarde met 12% gedaald. Wat is de auto nu waard?",
      "options": [
        "€13.200",
        "€13.800",
        "€3.000",
        "€16.800"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 12,
            "label": "12% waardedaling op €15.000 → €1.800 eraf, €13.200 over",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 12% waardedaling" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Waardedaling berekenen",
            "content": "Bereken de daling: 12% van €15.000 = 0,12 × 15.000 = €1.800. Trek af: €15.000 − €1.800 = €13.200. Of direct: €15.000 × 0,88 = €13.200.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_waardedaling",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.rekenfout", "label": "Verkeerd percentage gebruikt (8% i.p.v. 12%)", "optionIndex": 1 },
          { "id": "proc.afname-korting-als-eindbedrag", "label": "Geeft de daling als nieuwe waarde", "optionIndex": 2 },
          { "id": "proc.toename-als-afname", "label": "Telt de daling op i.p.v. aftrekken", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "12% van €15.000 = 0,12 × 15.000 = €1.800 waardedaling. Nieuwe waarde: €15.000 − €1.800 = €13.200. Je kunt ook direct rekenen: €15.000 × 0,88 = €13.200.",
        "solutionSteps": [
          "Bereken de daling: 12% van €15.000 = 0,12 × 15.000 = €1.800",
          "Trek af van de oorspronkelijke waarde: €15.000 − €1.800 = €13.200",
          "Check: €13.200 ÷ €15.000 = 0,88 = 88% → 12% minder ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 12% van 15.000 = 1.800. Nieuwe waarde: 15.000 − 1.800 = €13.200.",
          "1": "Je dacht waarschijnlijk dat de daling 8% was in plaats van 12%. 8% van 15.000 = 1.200, en 15.000 − 1.200 = 13.800. Maar de daling is 12%. Onthoud: reken altijd met het percentage uit de opgave.",
          "2": "Je dacht waarschijnlijk dat de daling 20% was. 20% van 15.000 = 3.000. Maar €3.000 is niet de nieuwe waarde — het zou de daling zijn bij 20%. Onthoud: de nieuwe waarde = oorspronkelijk − daling.",
          "3": "Je dacht waarschijnlijk dat je de daling moest optellen. Maar bij waardedaling trek je af, niet op. Onthoud: daling = aftrekken, stijging = optellen. €15.000 − €1.800 = €13.200."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-004",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een kledingverkoper zet alle prijzen 35% af tijdens de uitverkoop. Een jas kostte €185. Wat is de nieuwe prijs?",
      "options": [
        "€120,25",
        "€150",
        "€64,75",
        "€249,75"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 35,
            "label": "35% korting op €185 → €64,75 eraf, €120,25 te betalen",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 35% korting" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Uitverkoopprijs berekenen",
            "content": "Gebruik de 1%-methode: 1% van €185 = €1,85. Dan 35% = 35 × €1,85 = €64,75 korting. Nieuwe prijs: €185 − €64,75 = €120,25. Of direct: €185 × 0,65 = €120,25.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_uitverkoop",
      "variantIndex": 4,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "proc.korting-als-vast-bedrag", "label": "Trekt €35 af i.p.v. 35%", "optionIndex": 1 },
          { "id": "proc.afname-korting-als-eindbedrag", "label": "Geeft de korting als nieuwe prijs", "optionIndex": 2 },
          { "id": "proc.toename-als-afname", "label": "Telt de korting op i.p.v. aftrekken", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "35% van €185 = 0,35 × 185 = €64,75 korting. Nieuwe prijs: €185 − €64,75 = €120,25. Of direct: €185 × 0,65 = €120,25. Het niet-ronde startgetal voorkomt mentale shortcuts — je moet de 1%-methode of een directe vermenigvuldiging gebruiken.",
        "solutionSteps": [
          "1% van €185 = €1,85",
          "35% van €185 = 35 × €1,85 = €64,75 korting",
          "Trek af: €185 − €64,75 = €120,25",
          "Of direct: €185 × (1 − 0,35) = €185 × 0,65 = €120,25"
        ],
        "distractorExplanations": {
          "0": "Goed! 35% van €185 = €64,75 korting. Nieuwe prijs: €185 − €64,75 = €120,25.",
          "1": "Je dacht waarschijnlijk dat je €35 moest aftrekken van €185 (€185 − €35 = €150). Maar 35% is een percentage, geen vast bedrag. Onthoud: 35% van €185 = €64,75, niet €35.",
          "2": "Je dacht waarschijnlijk dat €64,75 de nieuwe prijs was. Maar €64,75 is de korting, niet wat de klant betaalt. Onthoud: nieuwe prijs = oude prijs − korting = €185 − €64,75 = €120,25.",
          "3": "Je dacht waarschijnlijk dat je de korting moest optellen. Maar bij korting trek je af: €185 − €64,75 = €120,25, niet €185 + €64,75 = €249,75. Onthoud: korting = aftrekken."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-005",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een inkoper bij een supermarkt koopt 425 kg appels in. Door bederf gaat 12% verloren. Hoeveel kilogram bruikbare appels blijft er over?",
      "options": [
        "374 kg",
        "413 kg",
        "51 kg",
        "476 kg"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 12,
            "label": "12% verlies op 425 kg → 51 kg weg, 374 kg over",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 12% verlies door bederf" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verlies door bederf berekenen",
            "content": "Gebruik de 1%-methode: 1% van 425 = 4,25 kg. Dan 12% = 12 × 4,25 = 51 kg verlies. Over: 425 − 51 = 374 kg. Of direct: 425 × 0,88 = 374 kg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_bederf_context",
      "variantIndex": 5,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "proc.korting-als-vast-bedrag", "label": "Trekt 12 kg af i.p.v. 12%", "optionIndex": 1 },
          { "id": "proc.afname-korting-als-eindbedrag", "label": "Geeft het verlies als overgebleven hoeveelheid", "optionIndex": 2 },
          { "id": "proc.toename-als-afname", "label": "Telt het verlies op i.p.v. aftrekken", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "12% van 425 kg = 0,12 × 425 = 51 kg gaat verloren door bederf. Er blijft over: 425 − 51 = 374 kg bruikbare appels. Het niet-ronde startgetal voorkomt mentale shortcuts — je moet écht rekenen.",
        "solutionSteps": [
          "1% van 425 = 4,25 kg",
          "12% van 425 = 12 × 4,25 = 51 kg verlies",
          "Trek af: 425 − 51 = 374 kg",
          "Check: 374 ÷ 425 = 0,88 = 88% → 12% verloren ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 12% van 425 = 51 kg verlies. Over: 425 − 51 = 374 kg.",
          "1": "Je dacht waarschijnlijk dat je 12 moest aftrekken in plaats van 12%. Maar 12% van 425 = 51 kg, niet 12 kg. Onthoud: 12% ≠ 12. Je moet het percentage berekenen: 0,12 × 425 = 51.",
          "2": "Je dacht waarschijnlijk dat 51 kg het antwoord was. Maar 51 kg is het verlies, niet wat er overblijft. Onthoud: overblijvend = totaal − verlies = 425 − 51 = 374 kg.",
          "3": "Je dacht waarschijnlijk dat je het verlies moest optellen. Maar bij verlies trek je af: 425 − 51 = 374, niet 425 + 51 = 476. Onthoud: verlies en afname = aftrekken."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-FILL-001",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "fill_in",
      "question": "Een fiets kostte €275. Tijdens de uitverkoop is er 28% korting. Wat is de nieuwe prijs in euro's? (alleen het getal invullen)",
      "options": [],
      "correctAnswer": "198",
      "data": {
        "acceptedAnswers": ["198", "€198", "198,00", "€198,00"]
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 28,
            "label": "28% korting op €275 → €77 eraf, €198 te betalen",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 28% korting" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Niet-ronde % — gebruik de 1%-methode",
            "content": "1% van €275 = €2,75. Dan 28% = 28 × €2,75 = €77. Trek af: €275 − €77 = €198. Of direct: €275 × 0,72 = €198.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "1% van €275 = €2,75. Dan 28% = 28 × €2,75 = €77 korting. Nieuwe prijs: €275 − €77 = €198. Of direct: €275 × 0,72 = €198. Tegenproef: €198 ÷ €275 = 0,72 = 72%, dus 28% korting ✓.",
        "solutionSteps": [
          "1% van €275 = €2,75",
          "28% = 28 × €2,75 = €77 korting",
          "Nieuwe prijs: €275 − €77 = €198",
          "Of direct: €275 × 0,72 = €198"
        ]
      }
    },
    {
      "id": "GET-PROC-AFNAME-CJ-001",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "comparison_judge",
      "question": "Eén van deze drie korting-uitspraken klopt niet. Welke?",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "28% korting op €75 → nieuwe prijs €54", "label": "achtentwintig procent korting op vijfenzeventig euro geeft nieuwe prijs vierenvijftig euro" },
            { "id": "b", "content": "35% korting op €160 → nieuwe prijs €112", "label": "vijfendertig procent korting op honderdzestig euro geeft nieuwe prijs honderdtwaalf euro" },
            { "id": "c", "content": "24% korting op €125 → nieuwe prijs €95", "label": "vierentwintig procent korting op honderdvijfentwintig euro geeft nieuwe prijs vijfennegentig euro" }
          ],
          "criterion": "de uitspraak die NIET klopt",
          "correctIndex": 1
        }
      },
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Korting controleren",
            "content": "Bereken het kortingsbedrag (percentage × oude prijs) en trek dat af van de oude prijs. Vergelijk met de uitspraak om te bepalen of die klopt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_judge",
      "variantIndex": 7,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Bij niet-ronde percentages moet je echt rekenen. Gebruik de 1%-methode: 1% = oude prijs ÷ 100, dan vermenigvuldigen met het percentage. Vergelijk met de uitspraak.",
        "solutionSteps": [
          "28% van 75 → 1% = 0,75, 28 × 0,75 = 21 → 75 − 21 = 54 ✓ (klopt)",
          "35% van 160 → 1% = 1,60, 35 × 1,60 = 56 → 160 − 56 = 104 (niet 112, dus fout)",
          "24% van 125 → 1% = 1,25, 24 × 1,25 = 30 → 125 − 30 = 95 ✓ (klopt)"
        ]
      }
    }
  ]
}
